import navsync from "../../../../assets/images/blogs/pp10/navsync.mp4";
import panecolor from "../../../../assets/images/docs/sync/panecolor.png";
import * as React from 'react';
export default {
  navsync,
  panecolor,
  React
};